define(["angular", "../../translate/translate"], function (angular) {
    "use strict";
    return angular.module("menuCommonsModule", ["translateModule"]);
});